<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { CardAdmin } from '@shared/ui/cards'

import { useLessonRecurringStore } from '../../model/lessons/recurring/store'
import { useLessonPrivileges } from '../../model/lessons/lesson-privileges.hook'
import LessonFormLayout from './LessonFormLayout.vue'
import LessonRecurringControls from './LessonRecurringControls.vue'
import LessonRecurringSchedule from './LessonRecurringSchedule.vue'
import LessonRecurringFilters from './LessonRecurringFilters.vue'
import ModalLessonRecurringTutor from './modals/ModalLessonRecurringTutor.vue'

defineOptions({
  name: 'LessonCreateRecurring',
})

const store = useLessonRecurringStore()
const { canCreateRecurring } = useLessonPrivileges()
</script>

<template>
  <CardAdmin
    title="Add new lesson"
    class="lesson-create-recurring"
    fullwidth
  >
    <template #header>
      <LessonRecurringControls v-if="canCreateRecurring" />
    </template>
    <LessonFormLayout v-if="canCreateRecurring">
      <template #main>
        <LessonRecurringSchedule />
      </template>
      <template #aside>
        <LessonRecurringFilters />
      </template>
    </LessonFormLayout>
    <AppText
      v-else
      class="lesson-create-recurring__denied"
      name="body2"
      color="slate-500"
    >
      You do not have permission to create recurring lessons.
    </AppText>
    <ModalLessonRecurringTutor v-if="store.getModal" />
  </CardAdmin>
</template>

<style scoped lang="scss" src="./LessonCreateRecurring.scss" />
